import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledBottomNavigation = styled.div<{
  isMoreMenuOpen?: boolean;
}>`
  position: relative;
  z-index: 10;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, ${({ isMoreMenuOpen }) => (isMoreMenuOpen ? 0.1 : 0.15)});
`;

export const StyledBottomNavigationButtons = styled.div`
  padding: 11px 0px 10px 0px;
  text-align: center;
  margin: 0 auto;
`;

export const StyledBottomNavigationMore = styled.div`
  background-color: ${COLORS.moreBackground};
`;
